import PropTypes from 'prop-types';
import { Navigate, useNavigate, useOutletContext } from 'react-router-dom';
import AccionaButton from '../../../../../../components/AccionaButton';
import styles from './index.module.scss';
import { useIntl } from 'react-intl';
import { COLUMNS_HEADERS } from './columns';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import * as actions from '../../../../../../services/redux/cemexTracking/actions';
import VolumeStatus from '../../../../../../components/VolumeStatus';
import { Divider, Tag } from 'antd';
import AntdDatePicker from '../../../../../../components/AntdDatePicker';
import { useState } from 'react';
import AccionaList, { Card } from '../../../../../../components/AccionaList';

const { expanded, buttons } = styles;

const STATUS_DICTIONARY = {
  WCL: { code: 'WCL', color: '#999999' },
  NTK: { code: 'NTK', color: '#999999' },
  ORT: { code: 'ORT', color: '#0370C3' },
  STR: { code: 'STR', color: '#0370C3' },
  FIN: { code: 'FIN', color: '#008000' },
  CNL: { code: 'CNL', color: '#0370C3' },
  BTG: { code: 'BTG', color: '#0370C3' },
  CAN: { code: 'CAN', color: '#FF0000' },
  OST: { code: 'OST', color: '#0370C3' },
  POU: { code: 'POU', color: '#0370C3' },
  CMP: { code: 'CMP', color: '#008000' },
  OHD: { code: 'OHD', color: '#999999' },
  NST: { code: 'NST', color: '#0370C3' },
  PHD: { code: 'PHD', color: '#FF0000' },
};

const List = ({ getCemexTrackingOrders }) => {
  const { project } = useOutletContext();
  const intl = useIntl();
  const navigate = useNavigate();
  const [date, setDate] = useState(dayjs());
  if (!project.concrete_providers.some((cp) => cp.provider === 'CEMEX')) {
    return <Navigate to="/" />;
  }
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12" style={{ paddingBottom: '50px' }}>
            <AccionaList
              pid={project.id_project.toString()}
              title={intl.formatMessage({ id: 'cemexTracking.list.title' })}
              isSelectionDisabled={(preRegister) => preRegister.prm_data}
              listExtra={
                <div className="row">
                  <div className={'col-sm-12 ' + buttons}>
                    <AntdDatePicker
                      value={date}
                      onChange={setDate}
                      style={{ width: '200px', backgroundColor: '#fff' }}
                      showTime={false}
                      format="DD/MM/YYYY"
                    />
                    <AccionaButton
                      id="viewMap"
                      type="white"
                      onClick={() => {
                        navigate('../map');
                      }}
                      classIcon="icon far fa-map"
                    />
                    <AccionaButton
                      id="viewMap"
                      type="white"
                      onClick={() => {
                        getCemexTrackingOrders({
                          filters: {
                            date: date.format('YYYY-MM-DD'),
                            project: project.id_project,
                          },
                        });
                      }}
                      classIcon="icon fas fa-sync"
                    />
                  </div>
                </div>
              }
              columns={COLUMNS_HEADERS}
              filters={{
                date: date.format('YYYY-MM-DD'),
              }}
              getItems={getCemexTrackingOrders}
              entity="cemexTracking"
              actions={undefined}
              itemExtra={(order) => (
                <div
                  style={{
                    position: 'absolute',
                    zIndex: 1,
                    top: 20,
                    right: 10,
                  }}
                >
                  <Tag
                    color={STATUS_DICTIONARY[order.orderStatusGroupCode].color}
                  >
                    {intl
                      .formatMessage({
                        id: 'cemex.status.' + order.orderStatusGroupCode,
                      })
                      .toLocaleUpperCase()}
                  </Tag>
                </div>
              )}
              expandable={{
                rowExpandable: (order) => {
                  return order.rawObject.orderStatusGroupCode !== 'WCL';
                },
                expandedRowRender: (row) => (
                  <>
                    <Divider />
                    <div className={expanded}>
                      <p>
                        {intl.formatMessage({
                          id: 'cemexTracking.list.expanded.title',
                        })}
                      </p>
                      {row.tickets.map((ticket) => (
                        <Card
                          key={ticket.ticketId}
                          columns={{
                            load: { align: 'center' },
                            docketNumber: { align: 'center' },
                            truck: { align: 'center' },
                            product: { align: 'center' },
                          }}
                          style={{
                            borderRadius: '10px',
                            border: '1px solid #ececec',
                            marginTop: '0px',
                          }}
                          itemExtra={(ticket) => (
                            <div
                              style={{
                                position: 'absolute',
                                zIndex: 1,
                                top: 20,
                                right: 10,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-end',
                              }}
                            >
                              <Tag
                                style={{ marginInlineEnd: '0px' }}
                                color={
                                  STATUS_DICTIONARY[ticket.ticketStatusCode]
                                    .color
                                }
                              >
                                {intl
                                  .formatMessage({
                                    id:
                                      'cemex.status.' + ticket.ticketStatusCode,
                                  })
                                  .toLocaleUpperCase()}
                              </Tag>
                              <p>
                                {ticket.totalDeliveredQuantity}{' '}
                                {ticket.unitOfMeasure || 'M3'}
                              </p>
                            </div>
                          )}
                          headingWidth="80px"
                          actions={(ticket) => {
                            return (
                              <>
                                {date.isSame(dayjs(), 'day') && (
                                  <AccionaButton
                                    id="createPreRegister"
                                    onClick={() => {
                                      navigate(`../../cemex/preregister`, {
                                        state: {
                                          ...ticket.rawObject,
                                        },
                                      });
                                    }}
                                    classIcon="icon fas fa-plus"
                                    msg={intl.formatMessage({
                                      id: 'cemexTracking.list.createPreRegister',
                                    })}
                                    type="default"
                                    size="small"
                                    style={{
                                      marginRight: '-20px',
                                    }}
                                  />
                                )}
                              </>
                            );
                          }}
                          data={{
                            ...ticket,
                            rawObject: ticket,
                            status: (
                              <Tag
                                color={
                                  STATUS_DICTIONARY[ticket.ticketStatusCode]
                                    .color
                                }
                              >
                                {intl
                                  .formatMessage({
                                    id:
                                      'cemex.status.' + ticket.ticketStatusCode,
                                  })
                                  .toLocaleUpperCase()}
                              </Tag>
                            ),
                            load: ticket.loadNumber,
                            docketNumber: ticket.ticketSourceCode,
                            truck: ticket.truckPlate,
                            product: ticket.productDesc,
                            quantity: (
                              <span>
                                {ticket.totalDeliveredQuantity}{' '}
                                {ticket.unitOfMeasure || 'M3'}
                              </span>
                            ),
                          }}
                        />
                      ))}
                    </div>
                  </>
                ),
              }}
              dataParseFunction={(orders) =>
                orders.map((order) => ({
                  ...order,
                  id: order.orderId,
                  rawObject: order,
                  product: order.tickets?.[0]?.productDesc,
                  loads:
                    (order.totalDeliveries || 0) +
                    '/' +
                    (order.totalLoads || 0),
                  programedDateTime: dayjs(order.programedDateTime).format(
                    'DD/MM/YYYY',
                  ),
                  volume: (
                    <VolumeStatus
                      total={order.totalQuantity || 0}
                      progress={order.deliveredQuantity || 0}
                      unit={order.unitOfMeasure || 'M3'}
                    />
                  ),
                }))
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

List.propTypes = {
  getCemexTrackingOrders: PropTypes.func.isRequired,
};

export { STATUS_DICTIONARY };
export default connect(() => ({}), {
  getCemexTrackingOrders: actions.getCemexTrackingOrders,
})(List);
